
import { Component, ElementRef, OnInit } from "@angular/core";

import { ActivatedRoute, Router } from "@angular/router";

import { NotificationService } from "src/app/Service/notification.service";

import { OtherService } from "src/app/Service/other.service";

import Chart from 'chart.js/auto';

import axios from "src/app/Service/axios";

import { Location } from '@angular/common';

import Map from 'ol/Map';

import View from 'ol/View';

import * as olProj from 'ol/proj';

import {

  DragRotateAndZoom,

  defaults as defaultInteractions,

} from 'ol/interaction';


import Feature from 'ol/Feature';

import { Tile as TileLayer } from 'ol/layer';

import OSM from 'ol/source/OSM';

import { Point } from "ol/geom";

import { BingMaps, Cluster, Vector } from "ol/source";

import AnimatedCluster from "ol-ext/layer/AnimatedCluster";

import SelectCluster from "ol-ext/interaction/SelectCluster";

import { Tile } from "ol/layer";

import { MapService } from "src/app/Service/map.service";

import { DeviceDetectorService } from "ngx-device-detector";

import { Circle, Fill, Icon, Stroke, Style, Text } from "ol/style";

import "ol/ol.css";

import * as XLSX from 'xlsx';

import zoomPlugin from 'chartjs-plugin-zoom';

import { getRelativePosition } from 'chart.js/helpers';

import { FormBuilder, FormControl, FormGroup, NgForm } from "@angular/forms";

import { DataService } from "src/app/Service/data.service";

import { Observable, map, startWith } from "rxjs";

import VectorSource from "ol/source/Vector";

import VectorLayer from "ol/layer/Vector";

import { animate, state, style, transition, trigger } from '@angular/animations';
import { GurdServiceService } from "src/app/Service/gurd-service.service";


declare let $: any;

@Component({

  selector: 'app-conferences',

  templateUrl: './conferences.component.html',

  styleUrls: ['./conferences.component.css']

})

export class ConferencesComponent implements OnInit {

  list_Events: any = [];

  list_comments: any = [];

  list_Albums: any = [];

  list_search: any = [];

  events: any = {};

  image_Data: any = [];

  dateFilter: FormGroup = this.FormBuilder.group({

    Date: new FormControl(''),

  })

  editMode: boolean = false;

  showImage: boolean = false;

  editAlbums: boolean = false;

  file: any;

  base64Img: string = '';

  isLoading: boolean = false;


  constructor(

    private location: Location,

    private Notification: NotificationService,

    private mapService: MapService,

    private router: Router,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService

  ) { }

  ngOnInit(): void {

    this.getEvents();

  }

  searchBy(search: any) {

    if (search.length > 2) {

      this.list_Events = this.list_search.filter((el: any) => {

        return el.strTitle.includes(search) || el.strDate.includes(search) || el.strMobileDomain_strComment.includes(search)

      })
    }

    else if (search == '') this.list_Events = this.list_search
  }

  async getEvents() {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

    }

    let res = JSON.parse((await axios.post(`Events_List`, model)).data.toString())

    this.list_Events = res;

    this.list_search = res;

    this.isLoading = false;

  }

  openModal(id: string, item?: any) {

    if (item) {

      this.events = item

      this.dateFilter.controls['Date'].setValue(item.strDate);

      this.editMode = true;

    }

    $(`#${id}`).modal('show');

  }

  closeModal() {

    this.editMode = false;

    this.events = {};

    const date = new Date().toLocaleDateString('fa-IR-u-nu-latn');

    this.dateFilter.controls['Date'].setValue(date);

  }

  async newEvent(form: NgForm) {

    if (form.invalid) return this.Notification.showError('لطفا عنوان را وارد کنید');

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      strTitle: form.value.strTitle,

      strComment: form.value.strComment,

      iEvents: ''

    }

    if (!this.editMode) {

      let res = JSON.parse((await axios.post(`Events_Save`, model)).data.toString());

      this.list_Events.push(res[0]);

      this.Notification.showSuccess('با موفقیت اضافه شد');

      $(`#Events`).modal('hide');


    }

    else {

      $.confirm({

        title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              model.iEvents = this.events.iEvents;

              let res = JSON.parse((await axios.post(`Events_Edit`, model)).data.toString())[0];

              const index = this.list_Events.indexOf(this.events);

              if (index != -1) this.list_Events[index] = res;

              this.Notification.showSuccess('با موفقیت ویرایش شد');

              $(`#Events`).modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  async deleteEvent(item: any) {

    $.confirm({

      title: `آیا از حذف این همایش اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {


            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iEvents: item.iEvents
            }

            let res = JSON.parse((await axios.post(`Events_Delete`, model)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('همایش با موفقیت حذف شد');

              const index = this.list_Events.indexOf(item);

              if (index != -1) this.list_Events.splice(index, 1)

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  async showComment(item: any) {

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iEvents: item.iEvents

    }

    let res = JSON.parse((await axios.post(`Events_LikeComment_List`, model)).data.toString());

    this.list_comments = res;

    this.openModal('comments')

  }

  async getAlbums(item: any) {

    this.isLoading = true;

    var model = {

      iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

      strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

      iEvents: item.iEvents

    }

    let res = JSON.parse((await axios.post(`Events_Gallery_List`, model)).data.toString());

    this.list_Albums = res;

    this.isLoading = false;

    this.openModal('gallery', item);

  }

  async deletePicture(item: any) {

    $.confirm({

      title: `آیا از حذف این تصویر اطمینان دارید ؟`,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iEvents_Gallery: item.iEvents_Gallery
            }

            let res = JSON.parse((await axios.post(`Events_Gallery_Delete`, model)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess('تصویر با موفقیت حذف شد');

              const index = this.list_Albums.indexOf(item);

              if (index != -1) this.list_Albums.splice(index, 1)

            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  onFileInput(file: any) {

    let extension = file.name.split('.').pop();

    if (extension !== 'jpeg' && extension !== 'jpg') this.Notification.showError(' فرمت قابل قبول فقط jpg است')

    if (extension === 'jpeg' || extension === 'jpg') {

      const reader: any = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = async () => {

        var base64String = reader.result.toString();

        this.base64Img = base64String;

        this.base64Img = this.base64Img.replace('data:image/jpeg;base64,', '');

        let description = prompt("توضیحات خود را وارد کنید !!", "");

        var model = {

          iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

          strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

          iEvents: this.events.iEvents,

          strComment: description,

          strImage: this.base64Img

        }

        $('#gallery').modal('hide')

        this.isLoading = true;

        let res = JSON.parse((await axios.post(`Events_Gallery_Save`, model)).data.toString());

        this.isLoading = false;

        this.getAlbums(this.events)

        if (res.iResult == 1) {

          this.getAlbums(this.events)

          return this.Notification.showSuccess('با موفقیت اضافه شد');

        }

      };

    }


  }

  showImageGallery(item: any) {

    this.image_Data = item;

    this.showImage = true;

  }

  openEditMode(item: any) {

    this.editAlbums = true;

    this.image_Data = item;

    this.showImage = true;

  }

  async editImage(value: string) {

    $.confirm({

      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,

      content: '',

      type: 'blue',

      buttons: {

        ok: {

          text: "ویرایش",

          btnClass: 'btn-primary',

          keys: ['enter'],

          action: async () => {

            var model = {

              iSystemUser: this.gurdService.decrypt(localStorage.getItem('ID')!),

              strSession: this.gurdService.decrypt(localStorage.getItem('Session')!),

              iEvents_Gallery: this.image_Data.iEvents_Gallery,

              strComment: value,

              strImage: this.image_Data.strImage
            }

            let res = JSON.parse((await axios.post(`Events_Gallery_Edit`, model)).data.toString());

            if (res.iResult == 0) return this.Notification.showError(res.strError);

            else {

              this.Notification.showSuccess(' با موفقیت ویرابش شد');

              this.getAlbums(this.events);

              this.showImage = false;


            }


          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }

  goBack() {

    this.router.navigate(['/'])

  }


}
